/* AULBERY — Featured review (quote card)
   Moved 1:1 from the inline <script> in snippets/as-featured-review.liquid.
   The script is emitted whether or not the card renders (it also binds the
   review row's [data-as-reviews-jump] links), so its two settings ride on the
   <script> tag itself: data-as-review-offset and data-as-review-fallback. */
(function () {
  var cfgEl = document.currentScript || document.querySelector('script[data-as-review-config]');
  var cfg = (cfgEl && cfgEl.dataset) || {};
  var scrollOffset = parseFloat(cfg.asReviewOffset);
  if (isNaN(scrollOffset)) scrollOffset = 70;
  var fallbackSelector = cfg.asReviewFallback || '[id*="reviews" i], .jdgm-rev-widg, #looxReviews, #okendo-reviews';

  function fallbackTarget() {
    if (!fallbackSelector) return null;
    try {
      return document.querySelector(fallbackSelector);
    } catch (err) {
      return null;
    }
  }

  function asrInit() {
    var links = document.querySelectorAll('[data-as-review-link], [data-as-reviews-jump]');
    links.forEach(function (link) {
      if (link.dataset.asrBound === '1') return;
      link.dataset.asrBound = '1';
      link.addEventListener('click', function (e) {
        var id = (link.getAttribute('href') || '').replace('#', '');
        var target = id ? document.getElementById(id) : null;
        if (!target) {
          target = fallbackTarget();
        }
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - scrollOffset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', asrInit);
  } else {
    asrInit();
  }
  document.addEventListener('shopify:section:load', asrInit);
  // only element listeners are registered (they go away with their elements),
  // so unload has nothing to release
  document.addEventListener('shopify:section:unload', function () {});
})();

